import React, { Component } from 'react'
import { connect } from 'react-redux'
import GoalServices from '../../../services/goal.services'
import ObjectiveFilter from './objectiveFilters.component'
import { okrDetailConstants } from '../../../constants/okr/okrDetails.constants'
import { withTranslation } from 'react-i18next';

class Filters extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      showOption: 0,
      openObjectiveFilter: false,
      filterDateArray: [],
      categoryList: [],
    }
    this.GoalServices = new GoalServices()
    this.openObjectiveFilter = this.openObjectiveFilter.bind(this)
    this.closeFilter = this.closeFilter.bind(this)
    this.filterButtonRef = React.createRef()
  }

  shouldComponentUpdate(nextProps, nextState) {
    let categories =
      this.props.filterDataSet &&
      typeof this.props.filterDataSet.categories != 'undefined' &&
      typeof nextProps.filterDataSet.categories != 'undefined'
        ? this.props.filterDataSet.categories ==
          nextProps.filterDataSet.categories
        : true
    let onlyClosedGoals = this.props.filterDataSet
      ? this.props.filterDataSet.onlyClosedGoals ==
        nextProps.filterDataSet.onlyClosedGoals
      : false
    let onlyOpenGoals = this.props.filterDataSet
      ? this.props.filterDataSet.onlyOpenGoals ==
        nextProps.filterDataSet.onlyOpenGoals
      : true
    let statusSet = this.props.filterDataSet
      ? this.props.filterDataSet.statusSet == nextProps.filterDataSet.statusSet
      : false
    let performance =
      this.props.filterDataSet && this.props.filterDataSet.performance
        ? this.props.filterDataSet.performance ==
          nextProps.filterDataSet.performance
        : true
    let startDate =
      this.props.filterDataSet && this.props.filterDataSet.startDate
        ? this.props.filterDataSet.startDate ==
          nextProps.filterDataSet.startDate
        : true
    let endDate =
      this.props.filterDataSet && this.props.filterDataSet.endDate
        ? this.props.filterDataSet.endDate == nextProps.filterDataSet.endDate
        : true
    let count = this.props.count == nextProps.count
    let dueStatus = this.props.dueStatus === nextProps.dueStatus
    let reRenderComp =
      !(
        categories &&
        performance &&
        startDate &&
        endDate &&
        onlyClosedGoals &&
        onlyOpenGoals &&
        statusSet &&
        count &&
        dueStatus
      ) ||
      this.state.openObjectiveFilter == true ||
      this.state.openObjectiveFilter != nextState.openObjectiveFilter
    if (
      (nextProps.sophisticatedCount == this.props.sophisticatedCount &&
        reRenderComp) ||
      this.state.filterDateArray.length !== nextState.filterDateArray.length
    ) {
      return true
    } else {
      return false
    }
  }

  openObjectiveFilter(e) {
    e.preventDefault()
    this.setState({
      openObjectiveFilter: !this.state.openObjectiveFilter,
    })
  }


  closeFilter (status, isTabbing = true) {
    this.setState(
      {
        openObjectiveFilter: status,
      },
      () => {
        if (isTabbing) {
          setTimeout(() => {
            document.getElementById('filterDate')?.focus()
          }, 100);
        }
      }
    )
  }

  closeObjectiveFilter(e) {
    // check if the calendar is open
    if (this.state.openObjectiveFilter) {
      let currNode = e.target;
      let inCalendarFilter = false;
      while (currNode && currNode.parentNode !== document.body) {
        if (currNode.classList.contains('select-panel') || currNode.classList.contains('chip') 
        || (currNode.parentNode && (currNode.parentNode.classList.contains('calendar-filter') || currNode.parentNode.classList.contains('chip') || currNode.parentNode.getAttribute('aria-label') == 'close'
        || (currNode.parentNode.parentNode && currNode.parentNode.parentNode.getAttribute('aria-label') == 'close')))
        || (currNode.firstElementChild && currNode.firstElementChild.classList.contains('searchlistspan'))
        || currNode.classList.contains('tag-name-heading')
        || currNode.classList.contains('SingleDatePicker_picker')
        ) {
          inCalendarFilter = true;
        }
        currNode = currNode.parentNode;
      }
      if (!inCalendarFilter) {
        this.setState({
        openObjectiveFilter: false
        });
      }
    }
  }

  componentDidMount() {
    const { startDate, endDate, exDate, categories, performance,
      onlyClosedGoals, onlyOpenGoals } = this.props.filterDataSet || {};
    let currentEnd = endDate;
    let currentStart = startDate;
    let statusVal = [];
    if (onlyOpenGoals) {
      statusVal.push(1);
    }
    if (onlyClosedGoals) {
      statusVal.push(2);
    }
    if (statusVal.length == 0) {
      statusVal.push(1);
    }
    const performanceVal = performance || okrDetailConstants.FILTER_PROGRESS_DEFAULT;
    const categoriesVal = categories || '';
    this.GoalServices.getFilterDate({ fromFilter: 1 }).then(response => {
        this.setState({
          filterDateArray: Object.values(response.data.filterComp)
        });
      });
    this.GoalServices.categoryList().then(response => {
    this.setState({
        categoryList: response.data.data
    });
    });
}


  render() {
    const { t } = this.props;
    const { showOption = 0, count } = this.props;
    const filterCount = count == 0 || !count ? ''
      : count;
    const filterVal = filterCount != '' && filterCount == 1
      ? t('filter') : t('filters');
    const filterText = filterCount != '' ? filterVal : '';
    const filterLabel = filterCount != ''
      ? `${filterCount} ${filterText} ${t('applied - Filter options')}`
      : t('Filter options');

    return (
      <div
        className="calendar-filter right"
        style={{
          paddingLeft: this.props.space ? '30px' : '0px',
          marginLeft: '10px',
        }}
      >
        {filterCount != '' && (
          <span
            className="countFilter"
            aria-hidden="true"
            style={{ marginRight: this.props.labelText && '6px' }}
          >
            {filterCount}
          </span>
        )}
        {this.props.labelText && <span>{this.props.labelText}</span>}
        <button
          ref={this.filterButtonRef}
          className="btn-nav-week rightEdgeEltooltip"
          onClick={this.openObjectiveFilter}
          id="filterDate"
          title={filterLabel}
          aria-label={filterLabel}
        >
          <span className="icon icon-outline-filter_list-24px" />
        </button>
        {this.state.filterDateArray.length > 0 && (
          <ObjectiveFilter
            anchorEl={this.filterButtonRef?.current}
            showOption={showOption}
            status={this.props}
            open={this.state.openObjectiveFilter}
            close={this.closeFilter}
            updateOkrFilterVal={this.props.updateOkrFilterVal}
            filterDateArr={this.state.filterDateArray}
            submitUrl={this.props.applyUrl}
            paramsList={this.props.paramsList}
            type={this.props.type}
            categoryList={this.state.categoryList}
            isReloadTab={this.props.isReloadTab || false}
            filterDataSet={this.props.filterDataSet}
            filterSelectedData={this.props.filterSelectedData}
            teams={this.props.teams}
            count={this.props.count}
            dueStatus={this.props.dueStatus}
          />
        )}
      </div>
    )
  }
}

const filterMapsStateToProps = (state) => {
  return state.okrDetailsReducer
}

export default connect(filterMapsStateToProps)(withTranslation()(Filters))
